import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { LIVE_TOOLS } from '../data/tools';

export default function FeaturedTools() {
  return (
    <section id="tools" className="py-20 sm:py-28 px-4 bg-gray-50/50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Featured Free Tools
          </h2>
          <p className="mt-3 text-gray-600 text-lg max-w-2xl mx-auto">
            Fully live browser-based utilities — read the guide on each landing page, then launch the tool when you are ready.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {LIVE_TOOLS.map((tool) => {
            const Icon = tool.icon;
            return (
              <article
                key={tool.id}
                className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all flex flex-col"
              >
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-brand-100 to-blue-100 flex items-center justify-center text-brand-600 mb-4">
                  <Icon size={22} />
                </div>
                <span className="text-xs font-medium text-green-700 bg-green-100 px-2.5 py-0.5 rounded-full w-fit">
                  Live
                </span>
                <h3 className="mt-3 font-semibold text-gray-900 text-lg">{tool.name}</h3>
                <p className="mt-2 text-sm text-gray-500 leading-relaxed flex-1">{tool.description}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  <Link
                    to={tool.landingPath}
                    className="inline-flex items-center px-4 py-2 rounded-full bg-brand-600 text-white text-sm font-medium hover:bg-brand-700 transition-colors"
                  >
                    Full Guide
                  </Link>
                  <a
                    href={tool.launchUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 px-4 py-2 rounded-full border border-gray-200 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
                  >
                    Launch
                    <ExternalLink size={14} />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
